import React, { useEffect, useState } from 'react';
import './blog.css';
import { useParams } from 'react-router-dom';

function BlogPage() {
    // Fetching data from the API localhost:5000/blog/getByName/{params}
    const [blog, setBlog] = useState([]); // Changed back to array
    const { blogID } = useParams();
    const [dataFetched, setDataFetched] = useState(false); // Track if data has been fetched
    const [loading, setLoading] = useState(true);

    const dateFormater = (date) => {
        const newDate = new Date(date);
        const month = newDate.toLocaleString('default', { month: 'long' });
        const day = newDate.getDate();
        const year = newDate.getFullYear();
        return `${month} ${day}, ${year}`;
    };

    const fetchData = () => {
        fetch(`https://portfolio-kappa-taupe-99.vercel.app/blog/getByName/${blogID}`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                setBlog(data);
                setLoading(false);
                setDataFetched(true);
            })
            .catch((error) => {
                console.error("Error fetching blog details:", error);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [blogID]);

    function Tagformat(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    return (
        <div>
            {loading && <p>Loading...</p>}
            {dataFetched && blog.length > 0 && (
                <div className='blog-content'>
                    <h1>{blog[0].title}</h1>
                    <div className="author">
                        <p>{blog[0].author} &nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp; {dateFormater(blog[0].date)}</p>
                    </div>
                    <div
                        dangerouslySetInnerHTML={{ __html: blog[0].content }}
                    />
                    <div className="blogtags">
                        {blog[0].tags.map((tag, index) => (
                            <div key={index} className="blog-tags">{Tagformat(tag)}</div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

export default BlogPage;
